"use client";

import { useTranslations } from "next-intl";
import React, { ComponentPropsWithRef, forwardRef, useEffect, useRef } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

import CheckBox from "@/components/ui/Form/CheckBox/CheckBox";
import { controlledCheckbox } from "@/components/ui/Form/Filters/FilterUtils";

export interface YearBaseProps extends ComponentPropsWithRef<"input"> {
  name: string;
  filter: string;
  displayInSearchBar?: boolean;
  values?: (string | number)[] | undefined;
  field?: ControllerRenderProps;
  fieldState?: ControllerFieldState;
  parentForm?: string;
  availableValues?: (string | number)[] | undefined;
}

const YearBase = forwardRef<HTMLInputElement, YearBaseProps>(
  ({ name, filter, displayInSearchBar = false, field, fieldState, values, availableValues, ...rest }, ref) => {
    return (
      <div className={`pt-xs px-m grid grid-flow-col grid-rows-10 pb-m`}>
        {values?.map((value) => {
          const filedUID = `filter-${name}-${value}`;
          return (
            <CheckBox
              checked={field?.value ? field.value.includes(value as string) : false}
              key={filedUID}
              label={value as string}
              name={name}
              value={value}
              onChange={(event) => controlledCheckbox(field, event)}
              //disabled={availableValues && availableValues.length > 0 ? !availableValues?.includes(value) : false}
            />
          );
        })}
      </div>
    );
  },
);
YearBase.displayName = "YearBase";
export default YearBase;
